// import me from "./me"

// This is needed for the slice to parse and fullfill the actions when
// the thunks are successfully processed + handling error/loading state
const allThunks = {}
export default allThunks

// This export is to improve the readability of the code when importing the actions
// from the components that use the thunks.
export {}
